import React, { memo, useMemo, useEffect } from "react";
import "../../../assets/scss/themes.scss";
import { configureStore } from "../../../store/messenger/store";
import { Provider } from "react-redux";
import "./index.css";
import Layout from "../Chats/Layout";
import Videocall from "./Videocall";
import { useCallContext } from "../../../store/context/CallProvider";
import { useSocket } from "../../../store/context/SocketProvider";
import UserChat from "../Chats/UserChat";
import { useSelector, useDispatch } from "react-redux";
import {
  updateMessages,
  deleteMessage,
  updateContacts,
  updateConversations,
  deleteContacts,
} from "../../../store/messengerSlice";

const VideocallIndex = memo(() => {
  const dispatch = useDispatch();
  const messenger = useSelector((state) => state.messenger);
  const { me } = useSocket();
  
  // Call context props
  const {
    remoteUser,
    localStream,
    remoteStream,
    closeCall,
    startVideo,
    stopVideo,
    toggleMute,
    isVideoTrack,
    isMuted,
    isVideo,
  } = useCallContext();

  // Memoize streams using JSON.stringify for MediaStream comparison
  const stableLocalStream = useMemo(() => localStream, [
    JSON.stringify(localStream?.getTracks().map(t => t.id))
  ]);
  
  const stableRemoteStream = useMemo(() => remoteStream, [
    JSON.stringify(remoteStream?.getTracks().map(t => t.id))
  ]);

  // Memoize dispatch functions
  const messengerActions = useMemo(() => ({
    setMessages: (obj) => dispatch(updateMessages({
      key: messenger.activeUser,
      message: obj,
    })),
    deleteMessage: (id) => dispatch(deleteMessage({ id })),
    updateContacts: (cntcts) => dispatch(updateContacts(cntcts)),
    updateConversations: (data) => dispatch(updateConversations([data])),
    deleteConversation: (id) => dispatch(deleteContacts(id))
  }), [dispatch, messenger.activeUser]);

  // Debug remote stream
  useEffect(() => {
    if (stableRemoteStream) {
      console.log('Remote stream updated:', {
        id: stableRemoteStream.id,
        active: stableRemoteStream.active,
        tracks: stableRemoteStream.getTracks().map(t => ({
          id: t.id,
          kind: t.kind,
          readyState: t.readyState,
          enabled: t.enabled,
          muted: t.muted
        }))
      });
    }
  }, [stableRemoteStream]);

  return (
    <Provider store={configureStore()}>
      <Layout>
        <Videocall
          currentUser={me}
          remoteUser={remoteUser}
          localStream={stableLocalStream}
          remoteStream={stableRemoteStream}
          closeCall={closeCall}
          startVideo={startVideo}
          stopVideo={stopVideo}
          toggleMute={toggleMute}
          isVideoTrack={isVideoTrack}
          isMuted={isMuted}
          isVideo={isVideo}
        />
        
        <div className="w-[40%] bg-white rounded-md mt-6 flex flex-col gap-1 p-2 ml-2" id="call-chat">
          <div className="w-full">
            <div className="text-black text-2xl py-2 pl-2">Chat</div>
            <UserChat
              isForVideoChat={true}
              contacts={messenger.contacts}
              currentUser={messenger.currentUser}
              active_user={messenger.activeUser}
              conversations={messenger.conversations}
              setMessagestoState={messengerActions.setMessages}
              deleteMessageFromState={messengerActions.deleteMessage}
              updateContacts={messengerActions.updateContacts}
              conversationsIds={messenger.conversationsIds}
              handleUpdateConversations={messengerActions.updateConversations}
              handleDelConversation={messengerActions.deleteConversation}
            />
          </div>
        </div>
      </Layout>
    </Provider>
  );
});

export default VideocallIndex;